import { useCallback, useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Btn, Spinner } from "@/components/rp";
import { CantiereHero } from "@/components/CantiereHero";
import { PhaseList } from "@/components/PhaseList";
import { PhotoGrid } from "@/components/PhotoGrid";
import { PhaseDialog, UploadPhotoDialog } from "@/components/admin/dialogs";

export const CantiereWork = ({ cantiereId, admin = false, hero = false, children }) => {
  const [c, setC] = useState(null);
  const [phase, setPhase] = useState(null);
  const [upload, setUpload] = useState(false);
  const load = useCallback(() => api.get(`/cantieri/${cantiereId}`).then((r) => setC(r.data)).catch(() => setC(false)), [cantiereId]);
  useEffect(() => { if (cantiereId) load(); }, [cantiereId, load]);
  const merge = (data) => setC((p) => ({ ...p, ...data, photos: p.photos, documents: p.documents, client_name: p.client_name }));
  const toggle = async (t) => {
    try { merge((await api.patch(`/cantieri/${cantiereId}/tasks/${t.id}`)).data); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!cantiereId || c === false) return null;
  if (!c) return <Spinner />;
  return (
    <div className="space-y-6" data-testid="cantiere-work">
      {hero && <CantiereHero c={c} photosCount={c.photos.length}>{children}</CantiereHero>}
      <div className="grid min-[900px]:grid-cols-[1.1fr_1fr] gap-6">
        <div className="rp-card p-5 sm:p-6" data-testid="cantiere-work-phases">
          <p className="rp-label mb-1">Diario lavori</p>
          <p className="text-xs text-[#757575] mb-4">{admin ? "Clicca un'attività per spuntarla, o gestisci la fase per note e nuove attività." : `Avanzamento in cantiere: ${c.progress}% · ${c.current_phase}`}</p>
          <PhaseList phases={c.phases} admin={admin} onToggleTask={toggle} onManage={setPhase} />
        </div>
        <div className="rp-card p-5 sm:p-6" data-testid="cantiere-work-photos">
          <div className="flex items-center justify-between mb-4">
            <p className="rp-label">Foto dal cantiere</p>
            {admin && <Btn variant="outline" className="h-9" onClick={() => setUpload(true)} data-testid="cantiere-work-upload-photo"><Camera className="h-4 w-4" /> Carica foto</Btn>}
          </div>
          <PhotoGrid photos={c.photos} phases={c.phases} />
        </div>
      </div>
      {admin && phase && <PhaseDialog cantiere={c} phase={phase} onClose={() => setPhase(null)} onSaved={merge} />}
      {admin && <UploadPhotoDialog open={upload} onClose={() => setUpload(false)} cantiere={c} onSaved={load} />}
    </div>
  );
};
